import React, {useState} from "react";
import {DialogContent} from "@mui/material";
import {Col} from "reactstrap";
import * as Yup from "yup";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import Button from "../../../../base/button/button";
import Form from "../../../../base/form";
import {OutlinedDropdownForm} from "../../../../base/dropdown/outlined_dropdown";
import Api from "../../../../../../core/services/api/api";
import useAccessLevels from "../../../../../hooks/use-access-levels";

const schema = Yup.object().shape({
    reason: Yup.object().nullable().required(ValidateMessages.required)
});


const validate = makeValidate(schema);
const required = makeRequired(schema);


const SubmitBypassSection = ({
                                 reasons,
                                 customer,
                                 setInEditMode,
                                 setSubmissionErrors,
                                 onBypassSuccess,
                                 orderId,
                             }) => {
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();
    const {packages} = useAccessLevels();
    const canManageReasons = packages.sales.manageQuoteBypassReasons;

    /**
     * Submits a bypass record for the provided user and order.
     * @param {any} values form values.
     * @return {Promise<void>}
     */
    const submitOrderBypass = async (values) => {
        const forApi = {
            orderId: orderId,
            reasonId: values.reason?.id,
        }
        setSubmitting(true);
        const response = await Api.submitQuoteBypass(forApi);
        if (!isMounted()) return;
        setSubmitting(false);
        if (!response?.resultFlag && !!response?.data?.errorModel) {
            // we have submission error
            setSubmissionErrors(response.data.errorModel);
        }
        if (response?.resultFlag && response?.data?.successModel) {
            onBypassSuccess(response.data.successModel);
        }
        return Promise.resolve();
    }

    return (
        <>
            <DialogContent className={'px-2'}>
                <Col xs={12} className={'mb-4 mt-4'}>
                    <p className={'text-sm font-weight-regular mt-2 mb-2'}>
                        You are going to submit a Bypass record for <span className={'mx-1 font-weight-bold'}>
                        {customer?.name ?? ""}.</span>please
                        choose the most related reasons for submitting this record to generate its respective
                        sales order.
                    </p>
                </Col>
                <Col xs={12} className={'mb-4'}>
                    <Form
                        className='d-flex flex-wrap w-100 align-items-start'
                        onSubmit={submitOrderBypass}
                        validate={validate}
                        initialValues={{}}
                        render={() => {
                            return (
                                <>
                                    <Col className={'p-0'}>
                                        <OutlinedDropdownForm
                                            name={'reason'}
                                            label={"Reason"}
                                            required={!!required.reason}
                                            data={reasons?.map(e => ({
                                                id: e.id,
                                                label: e.title,
                                                value: e,
                                            }))}
                                        />
                                    </Col>
                                    <Col xs={'auto'} className={'d-flex flex-column mt-1'}>
                                        <Button
                                            className='py-2-5 px-5 m-auto'
                                            type={'submit'}
                                            color={'primary'}
                                            variant={'contained'}
                                            disabled={submitting}
                                        >
                                            {
                                                submitting
                                                    ? "Submitting..."
                                                    : "Submit"
                                            }
                                        </Button>
                                        {canManageReasons &&
                                        <Button
                                            className='mt-3 px-2 m-auto'
                                            type={'button'}
                                            color={'primary'}
                                            variant={'text'}
                                            onClick={() => setInEditMode(true)}
                                            disabled={submitting}
                                        >
                                            Edit Reasons
                                        </Button>
                                        }
                                    </Col>
                                </>
                            )
                        }}
                    />
                </Col>
            </DialogContent>
        </>
    );
}
export default SubmitBypassSection;
